export enum ToastId {
    OTP_SUCCESS_TOAST = 'otp_success_toast_id',
    OTP_ERROR_TOAST = 'otp_error_toast_id',
    DOCUMENT_SUCCESS_TOAST = 'document_success_toast_id',
    DOCUMENT_ERROR_TOAST = 'document_error_toast_id',
    LOGIN_SUCCESS_TOAST = 'login_success_toast_id',
    LOGIN_ERROR_TOAST = 'login_error_toast_id',
    ANNOTATION_SUCCESS_TOAST = 'annotation_success_toast_id',
    ANNOTATION_ERROR_TOAST = 'annotation_error_toast_id',
    ANONYMIZATION_SUCCESS_TOAST = 'anonymization_success_toast_id',
    ANONYMIZATION_ERROR_TOAST = 'anonymization_error_toast_id',
    MEMBER_SUCCESS_TOAST = 'member_success_toast_id',
    UPDATE_ROLE_SUCCESS_TOAST = 'update_role_success_toast_id',
    UPDATE_ROLE_FAILED_TOAST = 'update_role_failed_toast_id',
    MEMBER_ERROR_TOAST = 'member_error_toast_id',
    PROJECT_SUCCESS_TOAST = 'project_success_toast_id',
    PROJECT_ERROR_TOAST = 'project_error_toast_id',
    ORGANIZATION_SUCCESS_TOAST = 'organization_success_toast_id',
    ORGANIZATION_ERROR_TOAST = 'organization_error_toast_id',
    LOGS_SUCCESS_TOAST = 'logs_success_toast_id',
    LOGS_ERROR_TOAST = 'logs_error_toast_id',
    INVITATION_SUCCESS_TOAST = 'invitation_success_toast_id',
    INVITATION_ERROR_TOAST = 'invitation_error_toast_id',
    VALIDATION_ERROR_TOAST = 'validation_error_toast_id',
    SUCCESS_TOAST = 'success_toast_id',
    ERROR_TOAST = 'error_toast_id',
    RETRY_TOAST_SUCCESS = 'retry_toast_success',
    RETRY_TOAST_ERROR = 'retry_toast_error',
    PARAMETER_UPDATED_TOAST = 'parameter_toast_updated_success_id',
    PARAMETER_RESET_TOAST = 'parameter_toast_reset_success_id',
    ASSIGN_PROJECT_TOAST = 'assign_project_toast_id',
    ROLE_UPDATE_TOAST = 'role_update_toast_id',
    REMOVE_ROLE_TOAST = 'remove_role_toast_id',
    WORDLIST_ERROR_TOAST = 'word_list_error_toast_id',
    WORDLIST_CREATION_TOAST = 'word_list_creation_toast_id',
    WORDLIST_CONFLICT_TOAST = 'word_list_conflict_toast_id',
    WORDLIST_SAVED_TOAST = 'word_list_saved_toast_id',
    DELETE_TEMPLATE_SUCCESS_TOAST = 'delete_template_success_id',
    DELETE_TEMPLATE_ERROR_TOAST = 'delete_template_error_id',
    WORDS_ADDED_SUCCESS_TOAST = 'words_added_success_id',
    WORDS_ADDED_FAILURE_TOAST = 'words_added_failure_id',
    WORDS_CLEARED_SUCCESS_TOAST = 'words_cleared_success_id',
    WORDS_CLEARED_FAILURE_TOAST = 'words_cleared_failure_id',
    CONFIG_SUCCESS_TOAST = 'config_success_id',
    ORG_CONFIG_SUCCESS_TOAST = 'org_config_success_id'
}
